export default __webpack_public_path__ + "static/media/radioButtonChecked.1e96db5b.png";